import { combineReducers } from 'redux';
import AEMContentReducer from './aem';
import appReducer from './app';
import loaderReducer from './loader';
import errorReducer from './error';
import questionnaireReducer from './questionnaire';
// import goalquestionnaireReducer from './goalquestionaire';
import resultsReducer from './results';
import dynamicLandingReducer from './dynamicLanding';
import recommendationReducer from './bankerResults';
import sendEmailRecommendationsReducer from './sendEmail';
import authReducer from './auth.reducer';
import pageErrorReducer from './pageError.reducer';

const generalAppReducer = combineReducers({
    questionnaireReducer,
    appReducer,
    loaderReducer,
    resultsReducer,
    AEMContentReducer,
    errorReducer,
    dynamicLandingReducer,
    recommendationReducer,
    sendEmailRecommendationsReducer,
    authentication: authReducer,
    pageError: pageErrorReducer,
});

export default generalAppReducer;
